export default `
# CollegeApp

Created by [Jae Hyun Choe](https://github.com/andrew00917), [Kevin Joh](https://github.com/guitarguise), [Griffin Smalley](https://github.com/gsmalley10), and [Omid Tafti](https://github.com/oat1345)

Please be advised we do not own any part of the placeholder information present in this app and few images used for customization of the theme in this app, which are under [Kalamazoo College Policy](https://reason.kzoo.edu/is/policies/).

------

![mobile screenshot login](https://cloud.githubusercontent.com/assets/8836645/7637563/d587ec66-fa3c-11e4-8059-eff79691adfc.png)
![mobile screenshot main](https://cloud.githubusercontent.com/assets/8836645/7637565/d5894110-fa3c-11e4-8d68-831a08d93426.png)
![mobile screenshot side panel](https://cloud.githubusercontent.com/assets/8836645/7637566/d589e70a-fa3c-11e4-85c9-57b4d196af7f.png)
![mobile screenshot cafeteria](https://cloud.githubusercontent.com/assets/8836645/7637564/d5894a48-fa3c-11e4-852f-5b99f446df00.png)
![mobile screenshot sports](https://cloud.githubusercontent.com/assets/8836645/7637562/d5874f5e-fa3c-11e4-9fb9-d9fde5bcd34c.png)
![mobile screenshot events](https://cloud.githubusercontent.com/assets/8836645/7637567/d5913852-fa3c-11e4-8948-95f9571f8216.png)

------

### Motivation

This project was created with the intent to be used by Kalamazoo College as an official mobile app. The purpose was to improve the lives of students, faculty, and staff on campus. In addition, the mobile application would assist visiting students and parents with navigation through the campus to enhance their experience. Unfortunately, because of school's current licensing with a third party vendor, this project did not get to shine as we hoped.

### Limitations

* Timeline
  + Considering its overall size, the project was rushed in order to finish this prototype. Consequently, the code in this repo is functional but very rough and documentation is incomplete.
  + Despite the incompleteness, contributors have agreed to make this a public repo for the sole purpose of education. We hope this will be instrumental for students enrolled in mobile-related courses at, but not limited to, Kalamazoo College.
* Database
  + Although user login is supported, you will not be able to log in as a user without first connecting the project to a database or creating hardcoded users.
  + We have provided the "Guest Mode" login for visiting parents and students, and it serves perfectly for demo purpose.

------

* This app was created to improve the daily lives of the users who are on the campus of Kalamazoo College. A few of its functions in this demo state are as followed:
  + Academic calendar for 2014-2017 academic years
  + Dining hours and its availability
  + Upcoming campus events and selected event to be imported into user's device calendar

------

The project is protected under *Creative Commons (CC) License*. More detailed parts are described below:

* *Attribution*
  + The author must be attributed as the creator of the work. Beyond that, the work can be modified, distributed, copied and otherwise used.
* *Share Alike*
  + The work can be modified, distributed and so forth, but only under the same CC license.
* *Non-Commercial*
  + The work can be modified, distributed and so on, but not for commercial purposes. The work cannot be sold or make a profit for an individual, a group, or a company.
* *No Derivative Works*
  + The modified work cannot be distributed, otherwise one can copy and distribute the licensed work. This license prohibits one from creating work based on the original.

------

#### [Contact](http://www.techhab.com/meet-the-team/)
`;



// WEBPACK FOOTER //
// ./src/components/project-documentations/documentations/k-app.ts